import React from "react";
import styles from "./ErrorHosting.module.css";
import {CloudOff} from "lucide-react";

export default function ErrorHosting() {
  return (
    <section id="error" className="sectionContainer light">
      <div className={styles.containerError}>
        <div className={styles.message}>
          <div className={styles.iconError}>
            <CloudOff size={60} />
          </div>
          <h1>Ta strona jest obecnie niedostępna</h1>
          <h2>Przepraszamy, ale ta strona nie jest obecnie dostępna.</h2>

          <h3>
            Może to być spowodowane tymczasową przerwą techniczną lub
            aktualizacją usług. Prosimy spróbować ponownie później.
          </h3>
          <p>
            <a href="/#portfolio">Wróć do portfolio</a>
          </p>

          <h3>
            Jeżeli jesteś właścicielem tej strony i potrzebujesz pomocy
            technicznej,{" "}
            <a href="/#contact" className={styles.contactinfo}>
              skontaktuj się z nami{" "}
            </a>
            — pomożemy przywrócić jej działanie.
          </h3>
        </div>
      </div>
    </section>
  );
}
